module.exports = __webpack_public_path__ + "img/组 22.9d6635f8.png";